import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Folder, GapiBaseData, Document } from '../models/node.class';

declare var gapi;

@Injectable({ providedIn: 'root' })
export class GoogleDriveService {
  DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest';
  API_KEY = 'AIzaSyA_cmmJujEj8GgAEcchJbpahhEWYdQs4go';
  ROOT_DRIVE_ID = '1r6TMfldGjxXc6q_LeYUXlRMaKVOLAENw';
  FOLDER_MIME_NAME = 'application/vnd.google-apps.folder';
  SCOPES = 'https://www.googleapis.com/auth/drive.metadata.readonly https://www.googleapis.com/auth/drive.file'
  FILE_EXEPTION = new Set(['.DS_Store']);

  _driveStructure = new BehaviorSubject<(Folder | null)[]>(null);
  _mainViewStructure = new BehaviorSubject<(Folder | Document | null)[]>(null);
  _activeFolders = new BehaviorSubject<string[]>(null);
  _activeFolderName = new BehaviorSubject<string>(null);
  _activeFolderId = new BehaviorSubject<string>(null);

  globalData = new Map<String, Document[]>();
  globalFolderData = new Map<String, Folder[]>();
  activeFolders: string[] = [];

  constructor() {
    this.init();
  }

  init() {
    gapi.load('client', () => {
      gapi.client
        .init({
          apiKey: this.API_KEY,
          discoveryDocs: [this.DISCOVERY_DOC],
        })
        .then(() => {
          gapi.client.load('drive', 'v3', () => {
            gapi.client.drive.files
              .list({
                fields: '*',
                q: `'${this.ROOT_DRIVE_ID}' in parents`,
              })
              .then((response) => {
                let driveStructureTemp: Folder[] = [];
                const data = response.result.files;

                data.forEach((element: GapiBaseData) => {
                  const node = this.factory(element);
                  node.setRoot(true);
                  if (node instanceof Folder) {
                    driveStructureTemp = [...driveStructureTemp, node];
                  }
                });
                this.globalFolderData.set('root', driveStructureTemp);
                this._driveStructure.next(driveStructureTemp);

                this.init2()
              });
          });
        });
    });
  }

  getFolderDetails(folderCmp, folder: Folder, index: number) {
    if (this.globalData.has(folder.data.id)) {
      const data = this.globalData.get(folder.data.id);
      this._mainViewStructure.next(data);
      this.setActiveFolder(folder.data.id, index);
      this._activeFolderName.next(folder.data.name);
      this._activeFolderId.next(folder.data.id);

    } else if (this.globalFolderData.has(folder.data.id)) {
      folderCmp.set(this.globalFolderData.get(folder.data.id));
      this.setActiveFolder(folder.data.id, index);
    } else {
      // Google give me the data of the folder
      gapi.client.drive.files
        .list({
          fields: '*',
          q: `'${folder.data.id}' in parents`,
        })
        .then((response) => {
          let driveStructureTemp: Folder[] = [];
          let mainViewStructureTemp: (Folder | Document)[] = [];
          const data = response.result.files;

          data.forEach((element: GapiBaseData) => {
            const node = this.factory(element);
            if (node instanceof Folder) {
              driveStructureTemp = [...driveStructureTemp, node];
            }

            if (node instanceof Document) {
              mainViewStructureTemp = [...mainViewStructureTemp, node];
            }
          });

          if (mainViewStructureTemp.length > 0 && mainViewStructureTemp[0]) {
            this.globalData.set(folder.data.id, mainViewStructureTemp);
            this._mainViewStructure.next(mainViewStructureTemp);
            this._activeFolderName.next(folder.data.name);
            this._activeFolderId.next(folder.data.id);
          } else {
            this._mainViewStructure.next(null);
          }

          if (driveStructureTemp.length > 0 && driveStructureTemp[0]) {
            this.globalFolderData.set(folder.data.id, driveStructureTemp);
          }

          folderCmp.set(driveStructureTemp);

          this.setActiveFolder(folder.data.id, index);
        });
    }
  }

  init2() {
    gapi.client.drive.files
        .list({
          fields: '*',
          q: `'1c5rnDtDoLpqlsbhW-NG06RDd2v4ZRBtV' in parents`,
        })
        .then((response) => {
          let driveStructureTemp: Folder[] = [];
          let mainViewStructureTemp: (Folder | Document)[] = [];
          const data = response.result.files;

          data.forEach((element: GapiBaseData) => {
            const node = this.factory(element);
            if (node instanceof Folder) {
              driveStructureTemp = [...driveStructureTemp, node];
            }

            if (node instanceof Document) {
              mainViewStructureTemp = [...mainViewStructureTemp, node];
            }
          });

          if (mainViewStructureTemp.length > 0 && mainViewStructureTemp[0]) {

            this._mainViewStructure.next(mainViewStructureTemp);

          } else {
            this._mainViewStructure.next(null);
          }

        });
  }

  factory(node: GapiBaseData): Folder | Document {
    if (this.FILE_EXEPTION.has(node.name)) return;

    return node.mimeType === this.FOLDER_MIME_NAME
      ? new Folder(node)
      : new Document(node);
  }

  setActiveFolder(folderId, index) {
    const tableau = this._activeFolders.getValue();

    if (!tableau || tableau.length === 0) {
      this._activeFolders.next([folderId]);
    } else if (tableau.length === index) {
      const list = [...tableau, folderId];
      this._activeFolders.next(list);
    } else if (tableau.length > index) {
      const tableauIndex = tableau.findIndex((el) => el === folderId);
      if (tableauIndex && index != 0) {
        const list = tableau.slice(0, index);
        this._activeFolders.next(list);
      } else {
        this._activeFolders.next([folderId]);
      }
    }
  }
}
